import React from 'react'

export default function Communication_Settings() {
  return (
    <div className="border-2 border-gray-200 rounded-2xl mx-10 h-[50vh]">
      <div className='p-5 border-b-2 border-gray-200 text-gray-500 font-bold text-lg'>
        CommunicationSettings
      </div>
     </div>
  )
}
